import DelibranLogo from "../../assets/logo/logo-delibran.svg";
import { LuPanelLeftClose as FiSidebar } from "react-icons/lu";
import React, { useEffect, useState, useRef } from "react";
//Redux
import { useDispatch } from "react-redux";
//Components
import { AdminMenu } from "./sidebar/adminMenu";
import { AdminBar } from "./adminBar";
import { useLocation } from "react-router-dom";
import { AdminBarMobile } from "./sidebar/adminMenuMobile";
import { Alert } from "../../components/alert";
//Styles
import "./style.css";
import "./workspace.css";
import "./local-eats.css";
import {
  updateCorporationData,
  updateFloatPanel,
} from "../../reducers/userConfigSlice";
import { getSalesChannels } from "../../api/salesChannels";
import { getCatalogs } from "../../api/catalogs";
import { getCategories } from "../../api/categories";
//import Logo from "./../../assets/logo/isotipomv.svg";
import { getCorporationOwner } from "../../api/configuration";
import { LoaderComponent } from "../../components/loaderComponent";
import { getAlergens } from "../../api/products";
import { getAttributeGroups } from "../../api/attributes";
import { getOptionGroups } from "../../api/options";
import { useSelector } from "react-redux";

export default function Admin({ component }) {
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const sidebarRef = useRef(null);
  const { pathname } = useLocation();
  const previousPath = useRef(pathname);
  useEffect(() => {
    if (previousPath.current !== pathname) {
      dispatch(
        updateFloatPanel({ visible: false, queryId: null, isEmpty: true }),
      );
      previousPath.current = pathname;
    }
  }, [pathname, dispatch]);
  useEffect(() => setMobileMenuOpen(false), [pathname]);
  useEffect(() => {
    const media = window.matchMedia?.("(max-width: 750px)");
    if (!media) return;
    const closeDesktopMenu = () => {
      if (!media.matches) setMobileMenuOpen(false);
    };
    media.addEventListener("change", closeDesktopMenu);
    return () => media.removeEventListener("change", closeDesktopMenu);
  }, []);

  useEffect(() => {
    if (!mobileMenuOpen) return;
    const previous = document.activeElement;
    const sidebar = sidebarRef.current;
    const controls = () =>
      [
        ...sidebar.querySelectorAll(
          'button:not(:disabled),[role="button"][tabindex="0"],a[href]',
        ),
      ].filter((el) => el.getClientRects().length);
    controls()[0]?.focus();
    const keys = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        setMobileMenuOpen(false);
      }
      if (event.key !== "Tab") return;
      const elements = controls(),
        first = elements[0],
        last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    };
    sidebar.addEventListener("keydown", keys);
    return () => {
      sidebar.removeEventListener("keydown", keys);
      previous?.focus?.();
    };
  }, [mobileMenuOpen]);
  const userName = useSelector(
    (state) => state.aplicationConfig.userConfig.userData?.fullname,
  );
  const AvatarArea = () => (
    <div className="adminAvatarArea">
      <img className="adminBrandLogo" src={DelibranLogo} alt="Delibrán" />
      {(menuOpen || mobileMenuOpen) && (
        <span className="adminBrandCaption">Panel de administración</span>
      )}
    </div>
  );

  const getCorporationData = async () => {
    const responseChannels = await getSalesChannels();
    if (responseChannels && !responseChannels.error) {
      dispatch(
        updateCorporationData({ key: "channels", data: responseChannels.data }),
      );
    }
    const responseCatalogs = await getCatalogs();
    if (responseCatalogs && !responseCatalogs.error) {
      dispatch(
        updateCorporationData({ key: "catalogs", data: responseCatalogs.data }),
      );
    }
    const responseCategories = await getCategories();
    if (responseCategories && !responseCategories.error) {
      dispatch(
        updateCorporationData({
          key: "categories",
          data: responseCategories.data,
        }),
      );
    }
    const responseCorporationOwner = await getCorporationOwner();
    if (responseCorporationOwner && !responseCorporationOwner.error) {
      dispatch(
        updateCorporationData({
          key: "corporationOwner",
          data: responseCorporationOwner.data,
        }),
      );
    }
    const responseAttributes = await getAttributeGroups();
    if (responseAttributes && !responseAttributes.error) {
      dispatch(
        updateCorporationData({
          key: "attributes",
          data: responseAttributes.data,
        }),
      );
    }
    const responseAlergens = await getAlergens();
    if (responseAlergens && !responseAlergens.error) {
      dispatch(
        updateCorporationData({ key: "alergens", data: responseAlergens.data }),
      );
    }
    const responseOptions = await getOptionGroups();
    if (responseOptions && !responseOptions.error) {
      dispatch(
        updateCorporationData({ key: "options", data: responseOptions.data }),
      );
    }
  };

  useEffect(() => {
    getCorporationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex-start adminWorkspace">
      {mobileMenuOpen && (
        <button
          type="button"
          className="mobileAdminBackdrop"
          aria-label="Cerrar menú de navegación"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
      <div
        ref={sidebarRef}
        id="admin-sidebar"
        className={`${menuOpen ? "adminLeftSide" : "adminLeftSide adminLeftSideClosed"}${mobileMenuOpen ? " mobileAdminSidebarOpen" : ""}`}
        role={mobileMenuOpen ? "dialog" : "complementary"}
        aria-modal={mobileMenuOpen ? "true" : undefined}
        aria-label="Navegación de administración"
      >
        <AvatarArea />
        <AdminMenu menuOpen={menuOpen || mobileMenuOpen} />
        <div className="adminSidebarFooter">
          {menuOpen && (
            <div className="adminSessionIdentity">
              <span>{(userName || "U").slice(0, 1).toUpperCase()}</span>
              <div>
                <strong>{userName || "Usuario"}</strong>
                <small>Administración</small>
              </div>
            </div>
          )}
          <button
            type="button"
            className="adminCollapse"
            aria-label={menuOpen ? "Contraer menú" : "Expandir menú"}
            aria-pressed={menuOpen}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <FiSidebar aria-hidden="true" />
            {menuOpen && "Contraer menú"}
          </button>
        </div>
      </div>
      <div
        inert={mobileMenuOpen ? "" : undefined}
        className={
          menuOpen ? "adminRightSide" : "adminRightSide adminRightSideClosed"
        }
      >
        <AdminBar />
        <AdminBarMobile
          menuOpen={mobileMenuOpen}
          onMenuClick={() => setMobileMenuOpen((previous) => !previous)}
        />
        <div className="adminBody" id="adminBody">
          <LoaderComponent />
          {component}
        </div>
        <Alert />
      </div>
    </div>
  );
}
